import React, { useEffect, useState } from "react";
import TaskCard from "./TaskCard";
import { Grid, Container, Typography, CircularProgress } from "@mui/material";
import { TasksAPIService } from "../../services/api/TasksAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from "../../shared/constants";
import starIcon from "../../assests/Images/starIcon.png";
import lineIcon from "../../assests/Images/lineIcon2.png";
import joyLogo from "../../assests/Images/joyLogo.png";
import { Box } from "@mui/system";
import { useParams} from "react-router-dom";


const TaskBoard = ({access,type}) => {
  const { id,phoneNumber:phone } = useParams();
  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [doctorList, setDoctorList] = useState([]);
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });

  useEffect(() => {


    if((access ==="admin" && type === "tasks") || access === "user")
    {
      fetchTasksList();
    }

    if((access ==="admin" && type === "inquires") || access === "user")
    {
      fetchInquiriesList();
    }
  }, []);
  const fetchTasksList = () => {
    setLoading(true);
    let page = 1;
    TasksAPIService.taskListing("tasks",id,phone)
      .then((response) => {
        setSnackData({
          show: true,
          message: response.message || API_SUCCESS_MESSAGE.LISTING_FETCH,
          type: "success",
        });

        setTaskList(response);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const fetchInquiriesList = () => {
    setLoading(true);
    let page = 1;
    TasksAPIService.taskListing("inquiries",id,phone)
      .then((response) => {
        setSnackData({
          show: true,
          message: response.message || API_SUCCESS_MESSAGE.LISTING_FETCH,
          type: "success",
        });

        setDoctorList(response);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container sx={{ marginTop: 1,marginBottom: 4 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <img src={starIcon} alt="Star Icon" style={{ width: 60, height: "auto",marginTop:"40px" }} />
        <img src={joyLogo} alt="Joy Logo" style={{ width: 120, height: "auto" }} />
        <img src={lineIcon} alt="Line Icon" style={{ width: 60, height: "auto" ,marginTop:"40px"}} />
      </Box>
    {
      loading ?
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
        :

      <Grid container spacing={4}>
        {(access ==="admin" && type === "tasks") || access === "user" ?
        <Grid item xs={12} md={access === "user"? 6 : 12}>
          <TaskCard title="My To-Do List" data={taskList} type="tasks" phone={phone || id}/>
        </Grid>
        :""
        }
         {(access ==="admin" && type === "inquires") || access === "user" ?
        <Grid item xs={12} md={access === "user"? 6 : 12}>
          <TaskCard title="Question List for My Doctor" data={doctorList} type="doctorList" phone={phone || id}/>
        </Grid>
        :""
        }
      </Grid>
}
    </Container>
  );
};

export default TaskBoard;
